export default __webpack_public_path__ + "static/media/Ηρων_ΗΛ.aa322da7.png";